import React, { useEffect, useState } from "react";
import "../assets/CSS/style.css";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAdmin } from "../hook/useAdmin";

const Contact = () => {
  const location = useLocation();
  // const { saveContactus, loading } = useAdmin();

  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    lastName: "",
    phone: "",
    email: "",
  });

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        // Timeout gives React time to render the section
        setTimeout(() => {
          element.scrollIntoView({ behavior: "auto" });
        }, 0);
      }
    } else {
      // Optionally scroll to top if no hash
      window.scrollTo(0, 0);
    }
  }, [location]);

  // Define regex outside the component or at top level inside the component
  const NAME_REGEX = /^[a-zA-Z\s]*$/;
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const PHONE_REGEX = /^\d{0,10}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Always update form data first
    setFormData((prev) => ({ ...prev, [name]: value }));

    let errorMsg = "";

    switch (name) {
      case "name":
      case "lastName":
        if (!NAME_REGEX.test(value)) {
          errorMsg = "Only letters are allowed.";
        }
        break;

      case "phone":
        if (!PHONE_REGEX.test(value)) {
          return; // stop typing beyond 10 digits
        }
        if (value.length !== 10 && value.length > 0) {
          errorMsg = "Phone number must be numeric and up to 10 digits.";
        }
        break;

      case "email":
        if (value && !EMAIL_REGEX.test(value)) {
          errorMsg = "Enter a valid email address.";
        }
        break;

      default:
        break;
    }

    // Single state update for errors
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(formData.phone)) {
      setErrors((prev) => ({
        ...prev,
        phone: "Phone number must be exactly 10 digits.",
      }));
      return;
    }

    if (Object.values(errors).some((err) => err !== "")) {
      alert("Please fix the errors before submitting.");
      return;
    }

    // const payload = {
    //   firstName: formData.name,
    //   lastName: formData.lastName,
    //   phone: formData.phone,
    //   useremail: formData.email,
    //   message: formData.message,
    // };

    // await saveContactus(payload);

    console.log("Form submitted:", formData);
    alert("Your message has been sent!");

    setFormData({
      name: "",
      lastName: "",
      phone: "",
      email: "",
      message: "",
    });

    setErrors({
      name: "",
      lastName: "",
      phone: "",
      email: "",
    });
  };

  // Translate Code
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: "Contact Us",
      breadcrumb: "HOME",
      breadcrumbContact: "CONTACT US",
      heading: "Archaeology",
      heading1: "Museums",
      heading2: "Head Office",
      address1: "Head Office Address",
      address2: `Directorate of Archaeology and Museums,
                  St. George's Fort,
                  St. George's Hospital Complex,
                  Near CSMT, Fort,
                  Mumbai - 400001`,
      phone: "Phone",
      phone1: "022-22623480",
      Timings: "Timings.",
      Timings1: "10.30 am to 6.15 pm (Saturday and Sunday Office will be closed)",
      email: "Email",
      emailid: "mahaarchaeology@gmail.com",
      formname: "Name",
      formnamePlaceholder: "Ex. John",
      formlastname: "Last Name",
      formlastnamePlaceholder: "Ex. Doe",
      formcontact: "Phone No.",
      formcontactPlaceholder: "+91 ",
      formemail: "Email",
      formemailPlaceholder: "Ex. abcd123@gmail.com",
      formmessage: "Message",
      formmessagePlaceholder: "Type your message here...",
      submitButton: "Send Message",
    },
    मराठी: {
      title: "संपर्क साधा",
      breadcrumb: "मुख्यपृष्ठ ",
      breadcrumbContact: "संपर्क साधा",
      heading: "पुरातत्त्व ",
      heading1: "वस्तुसंग्रहालये",
      heading2: "मुख्य कार्यालय",
      address1: "मुख्य कार्यालय पत्ता",
      address2: `पुरातत्त्व व वस्तुसंग्रहालये संचालनालय
सेंट जॉर्ज किल्ला, 
सेंट जॉर्ज रुग्णालय आवार, 
छ.शिवाजी महाराज टर्मिनस जवळ,फोर्ट, 
मुंबई - ४०० ००१`,
      phone: "दूरध्वनी क्र.",
      phone1: "०२२-२२६२३४८०",
      Timings: "कार्यालयीन वेळ",
      Timings1: "सकाळी १०.३० ते सायंकाळी ६.१५ पर्यंत (शनिवार व रविवार कार्यालय बंद राहील)",
      email: "ई-मेल",
      emailid: "mahaarchaeology@gmail.com",
      formname: "नाव",
      formnamePlaceholder: "उदा. जॉन",
      formlastname: "आडनाव",
      formlastnamePlaceholder: "उदा. डो",
      formcontact: "फोन क्रमांक",
      formcontactPlaceholder: "+९१ ",
      formemail: "ईमेल",
      formemailPlaceholder: "उदा. abc123@gmail.com",
      formmessage: "संदेश",
      formmessagePlaceholder: "तुमचा संदेश येथे टाइप करा...",
      submitButton: "संदेश पाठवा",
    },
  };

  const t = content[selectedLang];

  const tableHeaders = [
    {
      key: "name",
      label: {
        English: "Name",
        मराठी: "नाव",
      },
    },
    {
      key: "post",
      label: {
        English: "Post",
        मराठी: "पद",
      },
    },
    {
      key: "division",
      label: {
        English: "Division",
        मराठी: "विभाग",
      },
    },
    {
      key: "address",
      label: {
        English: "Address",
        मराठी: "कार्यालयीन पत्ता",
      },
    },
    {
      key: "email",
      label: {
        English: "Email ID",
        मराठी: "ईमेल आयडी",
      },
    },
    {
      key: "contact",
      label: {
        English: "Contact Number",
        मराठी: "संपर्क क्रमांक",
      },
    },
  ];

  const tableHeaders1 = [
    {
      key: "name",
      label: {
        English: "Name",
        मराठी: "नाव",
      },
    },
    {
      key: "department",
      label: {
        English: "Department",
        मराठी: "पद",
      },
    },
    {
      key: "division",
      label: {
        English: "Division",
        मराठी: "विभाग",
      },
    },
    {
      key: "address",
      label: {
        English: "Address",
        मराठी: "कार्यालयीन पत्ता",
      },
    },
    {
      key: "email",
      label: {
        English: "Email ID",
        मराठी: "ईमेल आयडी",
      },
    },
    {
      key: "contact",
      label: {
        English: "Contact Number",
        मराठी: "संपर्क क्रमांक",
      },
    },
  ];

  const museumTableHeaders = tableHeaders.map((header) => {
    if (header.key === "division") {
      return {
        key: "museum",
        label: {
          English: "Museums",
          मराठी: "संग्रहालय",
        },
      };
    }
    return header;
  });

  const headoffice = [
    {
      id: 1,
      name: {
        English: "Dr. Tejas Madan Garge",
        मराठी: "डॉ. तेजस मदन गर्गे",
      },
      post: {
        English: "Head Office - Directorate of Archaelogy and Museums",
        मराठी: "संचालक",
      },
      division: {
        English: "Directorate of Archeology and Museums, Maharashtra State",
        मराठी: "मुख्य कार्यालय - पुरातत्त्व व वस्तुसंग्रहालये संचालनालय ",
      },
      address: {
        English:
          "St. George's Fort, St.George's Hospital Complex, Near CSMT, Fort, Mumbai - 400 001",
        मराठी:
          "सेंट जॉर्ज किल्ला, सेंट जॉर्ज रुग्णालय आवार, छ.शिवाजी महाराज टर्मिनस जवळ,फोर्ट, मुंबई - ४०० ००१",
      },
      email: "mahaarchaeology@gmail.com",
      contact: {
        English: "022-22623480",
        मराठी: "०२२-२२६२३४८०",
      },
    },
    {
      id: 2,
      name: {
        English: "Shri. Hemant N. Dalavi",
        मराठी: "श्री. हेमंत निवृत्ती दळवी",
      },
      post: {
        English: "Head Office - Directorate of Archaelogy and Museums",
        मराठी: "उपसंचालक",
      },
      division: {
        English: "Directorate of Archeology and Museums, Maharashtra State",
        मराठी: "मुख्य कार्यालय - पुरातत्त्व व वस्तुसंग्रहालये संचालनालय ",
      },
      address: {
        English:
          "St. George's Fort, St.George's Hospital Complex, Near CSMT, Fort, Mumbai - 400 001",
        मराठी:
          "सेंट जॉर्ज किल्ला, सेंट जॉर्ज रुग्णालय आवार, छ.शिवाजी महाराज टर्मिनस जवळ,फोर्ट, मुंबई - ४०० ००१",
      },
      email: "mahaarchaeology@gmail.com",
      contact: {
        English: "022-22623480",
        मराठी: "०२२-२२६२३४८०",
      },
    },
  ]

  const officials = [
    {
      id: 3,
      name: {
        English: "Dr. Vilas Vahane",
        मराठी: "डॉ. विलास वहाणे",
      },
      post: {
        English: "Assistant Director",
        मराठी: "सहायक संचालक",
      },
      division: {
        English: "Ratnagiri Division",
        मराठी: "रत्नागिरी विभाग",
      },
      address: {
        English: "Thibaw Palace, Gagangiri Maharaj Road, Ratnagiri - 415 612",
        मराठी: "थिबा राजवाडा, गगनगिरी महाराज मार्ग, रत्नागिरी - ४१५ ६१२",
      },
      email: "adaratnagiri0235@gmail.com",
      contact: {
        English: "02352-298849",
        मराठी: "०२३५२-२९८८४९",
      },
    },
    {
      id: 4,
      name: {
        English: "Shri. Amol Gote",
        मराठी: "श्री. अमोल गोटे",
      },
      post: {
        English: "Assistant Director",
        मराठी: "सहायक संचालक",
      },
      division: {
        English: "Nashik Division",
        मराठी: "नाशिक विभाग",
      },
      address: {
        English: "1411, Sarkarwada, Bohorpatti, Nashik - 422 001",
        मराठी: "१४११, सरकारवाडा, बोहरपट्टी, नाशिक - ४२२ ००१",
      },
      email: "adanashik@gmail.com",
      contact: {
        English: "0253-2507496",
        मराठी: "०२५३-२५०७४९६",
      },
    },
    {
      id: 5,
      name: {
        English: "Dr. Vilas Vahane",
        मराठी: "डॉ. विलास वहाणे",
      },
      post: {
        English: "Assistant Director",
        मराठी: "सहायक संचालक",
      },
      division: {
        English: "Pune Division",
        मराठी: "पुणे विभाग",
      },
      address: {
        English:
          "Sadanika No. G-4/1 B, G-4/2, Shivkirti, Government Quarters, Near Aayappa Temple, Ghorpadi, Pune - 411 001",
        मराठी:
          "सदनिका क्र.जी/१ बी, जी-४/२, शिवकीर्ती, शासकीय अधिकारी वसाहत, अयप्पा मंदिराजवळ, घोरपडी,पुणे- ४११ ००१",
      },
      email: "adapune77@gmail.com",
      contact: {
        English: "020-26688925",
        मराठी: "०२०-२६६८८९२५",
      },
    },
    {
      id: 6,
      name: {
        English: "Shrim. Jaya Vahane",
        मराठी: "श्रीमती. जया वहाणे",
      },
      post: {
        English: "Assistant Director",
        मराठी: "सहायक संचालक",
      },
      division: {
        English: "Chhtrapati Sambhajinagar Division",
        मराठी: "छत्रपती संभाजीनगर विभाग",
      },
      address: {
        English:
          "Soneri Mahal, Dr. BAMU Campus, Chhtrapati Sambhajinagar - 431 004",
        मराठी:
          "सोनेरी महल, डॉ. बी.ए.एम.यु. कॅम्पस, छत्रपती संभाजी नगर- ४३१ ००४",
      },
      email: "ada.aurangabad@gmail.com",
      contact: {
        English: "0240-2400269",
        मराठी: "०२०-२६६८८९२५",
      },
    },
    {
      id: 7,
      name: {
        English: "Shri. Amol Gote",
        मराठी: "श्री. अमोल गोटे",
      },
      post: {
        English: "Assistant Director",
        मराठी: "सहायक संचालक",
      },
      division: {
        English: "Nanded Division",
        मराठी: "नांदेड विभाग",
      },
      address: {
        English: "C/o. Dr. Dilip G. Mhaiskar, Kailas Nagar, Nanded - 431 602",
        मराठी: "पत्रव्यवहार डॉ. दिलीप म्हैसकर यांजकडे, कैलास नगर, नांदेड - ४३१ ६०२ ",
      },
      email: "ada.nanded@gmail.com",
      contact: {
        English: "0246-2250040",
        मराठी: "०२४६-२२५००४०",
      },
    },
    {
      id: 8,
      name: {
        English: "Shri. Mayuresh Khadke",
        मराठी: "श्री. मयुरेश खडके",
      },
      post: {
        English: "Assistant Director",
        मराठी: "सहायक संचालक",
      },
      division: {
        English: "Nagpur Division",
        मराठी: "नागपूर विभाग",
      },
      address: {
        English:
          "Civil Lines, In Front of the Government Press, Nagpur - 440 001",
        मराठी: "सिविल लाइन्स, शासकीय मुद्रणालया समोर, नागपूर - ४४० ००१",
      },
      email: "nagpurada0712@gmail.com",
      contact: {
        English: "0712-2561187",
        मराठी: "०७१२-२५६११८७",
      },
    },
  ];

  const museumStaff = [
    {
      id: 1,
      name: { English: "Dr. Vilas Vahane", मराठी: "डॉ. विलास वहाणे" },
      post: { English: "Curator", मराठी: "अभिरक्षक" },
      division: {
        English: "Ratnagiri Regional Museum",
        मराठी: "रत्नागिरी शासकीय संग्रहालय",
      },
      address: {
        English: "Thibaw Palace, Gagangiri Maharaj Road, Ratnagiri - 415 612",
        मराठी: "थिबा राजवाडा, गगनगिरी महाराज मार्ग, रत्नागिरी - ४१५ ६१२",
      },
      email: "ratnagirimuseum@gmail.com",
      contact: {
        English: "02352 -298849",
        मराठी: "०२३५२ -२९८८४९",
      },
    },
    {
      id: 2,
      name: { English: "Shri. Amol Gote", मराठी: "श्री अमोल गोटे" },
      post: { English: "Curator", मराठी: "अभिरक्षक" },
      division: {
        English: "Nashik Regional Museum",
        मराठी: "नाशिक शासकीय संग्रहालय",
      },
      address: {
        English: "1411, Sarkarwada,Bohorpatti, Nashik 422 001",
        मराठी: "१४११, सरकारवाडा, बोहरपट्टी, नाशिक - ४२२ ००१",
      },
      email: "nasikmuseum@gmail.com",
      contact: {
        English: "0253 -2508496",
        मराठी: "०२५३ -२५०८४९६",
      },
    },
    {
      id: 3,
      name: { English: "Shrim. Jaya Vahane", मराठी: "श्रीमती जया वाहणे" },
      post: { English: "Assistant Curator", मराठी: "सहायक अभिरक्षक" },
      division: {
        English: "Chatrapati Sambhajinagar Regional Museum",
        मराठी: "छत्रपती संभाजीनगर शासकीय संग्रहालय",
      },
      address: {
        English:
          "Soneri Mahal, Dr.BAMU Campus,Chatrapati Sambhajinagar - 431 004",
        मराठी:
          "सोनेरी महाल, डॉ. बी. ए. एम. यू आवार, छत्रपती संभाजीनगर-४३१ ००४",
      },
      email: "aurangabadmuseum@gmail.com",
      contact: {
        English: "0240-2400943",
        मराठी: "०२४०-२४००९४३",
      },
    },
    {
      id: 4,
      name: { English: "Shri. Amol Gote", मराठी: "श्री. अमोल गोटे" },
      post: { English: "Assistant Curator", मराठी: "सहायक अभिरक्षक" },
      division: {
        English: "Late Ramlingappa Lamture Government Museum, Ter",
        मराठी: "स्व. रामलिंगप्पा लमतुरे शासकीय संग्रहालय, तेर",
      },
      address: {
        English: "Ter, Taluka Osmanabad, District Osmanabad - 413 509",
        मराठी: "टेर, तालुका उस्मानाबाद, जिल्हा उस्मानाबाद - ४१३ ५०९",
      },
      email: "termuseum@gmail.com",
      contact: {
        English: "02472 - 233526",
        मराठी: "०२४७२ - २३३५२६",
      },
    },
    {
      id: 5,
      name: { English: "Shri. Amrut Patil", मराठी: "श्री. अमृत पाटील" },
      post: { English: "Assistant Curator", मराठी: "सहायक अभिरक्षक" },
      division: {
        English: "Sangli Regional Museum",
        मराठी: "सांगली शासकीय संग्रहालय",
      },
      address: {
        English: "Rajwada Campus, Sangli - 416 416",
        मराठी: "राजवाडा कॅम्पस, सांगली - ४१६ ४१६",
      },
      email: "sangali233museum@gmail.com",
      contact: {
        English: "033 - 2376913",
        मराठी: "०३३ - २३७६९१३",
      },
    },
    {
      id: 6,
      name: { English: "Shri. Pravin Shinde", मराठी: "श्री. प्रविण शिंदे" },
      post: { English: "Assistant Curator", मराठी: "सहायक अभिरक्षक" },
      division: {
        English: "Shri Chhatrapati Shivaji Maharaj Museum, Satara",
        मराठी: "श्री छत्रपती शिवाजी महाराज संग्रहालय, सातारा",
      },
      address: {
        English:
          "Shetkari Niwas, Market Yard, In front of ST Stand, Satara - 415 501",
        मराठी: "शेतकरी निवास, मार्केट यार्ड, एसटी स्टँड समोर, सातारा - ४१५ ५०१",
      },
      email: "sataramuseum@gmail.com",
      contact: {
        English: "02162 - 238235",
        मराठी: "०२१६२ - २३८२३५",
      },
    },
    {
      id: 7,
      name: { English: "Shri. Amrut Patil", मराठी: "श्री. अमृत पाटील" },
      post: { English: "Deputy Curator", मराठी: "उपअभिरक्षक" },
      division: {
        English: "Shri Bhawani Chitrasangrahalay and Library, Aundh",
        मराठी: "श्री भवानी चित्रसंग्रहालय व वाचनालय, औंध",
      },
      address: {
        English: "Aundh, Taluka Khatao, District Satara - 415 510",
        मराठी: "औंध, तालुका खटाव, जिल्हा सातारा - ४१५ ५१०",
      },
      email: "aundhmuseum@gmail.com",
      contact: {
        English: "02161 - 262230/262225",
        मराठी: "०२१६१ - २६२२३०/२६२२२५",
      },
    },
    {
      id: 8,
      name: { English: "Shri. Uday Surve", मराठी: "श्री. उदय सुर्वे" },
      post: { English: "Assistant Curator", मराठी: "सहायक अभिरक्षक" },
      division: {
        English: "The Government Museum, Kolhapur",
        मराठी: "शासकीय संग्रहालय, कोल्हापूर",
      },
      address: {
        English: "Town Hall, Kolhapur - 416 002",
        मराठी: "टाउन हॉल, कोल्हापूर - ४१६ ००२",
      },
      email: "kolhapurmuseum@gmail.com",
      contact: {
        English: "0231 - 2540481",
        मराठी: "०२३१ - २५४०४८१",
      },
    },
    {
      id: 9,
      name: { English: "Shri. Uday Surve", मराठी: "श्री. उदय सुर्वे" },
      post: { English: "Assistant Curator", मराठी: "सहायक अभिरक्षक" },
      division: {
        English: "Chandrakant Mandare Art Museum, Kolhapur",
        मराठी: "चंद्रकांत मांडरे कला संग्रहालय, कोल्हापूर",
      },
      address: {
        English: "7th Lane, Rajarampuri, Kolhapur - 416008",
        मराठी: "सातवी गल्ली, राजारामपुरी, कोल्हापूर - ४१६००८",
      },
      email: "kolhapurmuseum@gmail.com",
      contact: {
        English: "0231 - 2540481",
        मराठी: "०२३१ - २५४०४८१",
      },
    },
    {
      id: 10,
      name: { English: "Shrim. Jaya Vahane", मराठी: "श्रीमती जया वाहणे" },
      post: { English: "Curator", मराठी: "अभिरक्षक" },
      division: {
        English: "Shri. Balasaheb Patil Government Museum, Paithan",
        मराठी: "श्री. बाळासाहेब पाटील शासकीय संग्रहालय, पैठण",
      },
      address: {
        English:
          "Sant Dyaneshwar Garden Campus, Paithan, District Chhatrapati Sambhajinagar - 431 004",
        मराठी: "संत ज्ञानेश्वर गार्डन कॅम्पस, पैठण, जिल्हा छत्रपती संभाजी नगर - ४३१ ००४",
      },
      email: "paithanmuseum@gmail.com",
      contact: {
        English: "02431 - 224411",
        मराठी: "०२४३१ - २२४४११",
      },
    },
    {
      id: 11,
      name: {
        English: "Shri. Vinayak Nitturkar",
        मराठी: "श्री. विनायक निट्टूरकर",
      },
      post: { English: "Curator", मराठी: "अभिरक्षक" },
      division: {
        English: "The Government Museum, Sindhkhedraja",
        मराठी: "शासकीय संग्रहालय, सिंदखेडराजा",
      },
      address: {
        English: "Kalakot, Sindhkhedraja, District Buldhana - 443 2033",
        मराठी: "कलाकोट, सिंदखेडराजा, जिल्हा बुलढाणा - ४४३ २०३३",
      },
      email: "srajamuseum@gmail.com",
      contact: {
        English: "07269 - 234208",
        मराठी: "०७२६९ - २३४२०८",
      },
    },
    {
      id: 13,
      name: { English: "Shri. Mayuresh Khadke", मराठी: "श्री. मयुरेश खडके" },
      post: { English: "Curator", मराठी: "अभिरक्षक" },
      division: {
        English: "The Central Museum, Nagpur",
        मराठी: "सेंट्रल म्युझियम, नागपूर",
      },
      address: {
        English:
          "Civil Lines, In Front of the Government Press, Nagpur - 440 001",
        मराठी: "सिविल लाइन्स, शासकीय मुद्रणालया समोर, नागपूर - ४४० ००१  ",
      },
      email: "nagpurmuseum@gmail.com",
      contact: {
        English: "0712 - 2546314/2560231",
        मराठी: "०७१२ - २५४६३१४/२५६०२३१",
      },
    },
    {
      id: 12,
      name: {
        English: "Shri. Mayuresh Khadke",
        मराठी: "श्री. मयुरेश खडके",
      },
      post: { English: "Curator", मराठी: "अभिरक्षक" },
      division: {
        English: "The Government Museum, Mahur",
        मराठी: "शासकीय संग्रहालय, माहूर",
      },
      address: {
        English: "Mahur, Taluka Nanded, District Nanded - 431 721",
        मराठी: "माहूर, तालुका नांदेड, जिल्हा नांदेड - ४३१ ७२१",
      },
      email: "nagpurmuseum@gmail.com",
      contact: {
        English: "02460 - 268444",
        मराठी: "०२४६० - २६८४४४",
      },
    },
    {
      id: 14,
      name: { English: "Shri. Uday Surve", मराठी: "श्री. उदय सुर्वे" },
      post: { English: "Assistant Curator", मराठी: "सहाय्यक अभिरक्षक  " },
      division: {
        English: "Lakshmi Vilas Palace",
        मराठी: "लक्ष्मी विलास  पॅलेस",
      },
      address: {
        English:
          "Lakshmi Vilas Palace, Near D.Y.Patil College of Engineering, Kasba Bavada, Kolhapur, Maharashtra",
        मराठी:
          "लक्ष्मी विलास  पॅलेस, डी.वाय.पाटील अभियांत्रिकी आणि तंत्रज्ञान महाविद्यालया जवळ, कसबा बावडा, कोल्हापूर, महाराष्ट्र",
      },
      email: "curatorlvp1874@gmail.com",
      contact: {
        English: "0231-2540481/2600551",
        मराठी: "०२३१-२५४०५८१/२६००५५१",
      },
    },
  ];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      <div style={{ fontFamily: "Canto" }}>
        {/* Title */}
        <div className="text-center mb-8">
          <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
            {/* Contact Us */}
            {t.title}
          </h1>
          <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
            <span style={{ color: "#DD9827" }}>
              <Link to="/" className="hover:underline">
                {t.breadcrumb}
              </Link>{" "}
              /{" "}
            </span>
            {t.breadcrumbContact}
          </p>
        </div>

        {/* Grid Layout */}
        <div
          className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-y-10 md:gap-x-12 px-4 sm:px-10 md:px-8 lg:px-20 items-start py-14"
          style={{
            color: "#4a4a4a",
          }}
        >
          {/* Left Side Info: 4 columns */}
          <div className="space-y-14 info w-full md:col-span-5">
            <p>
              <span className="text-[16px] sm:text-[17px] md:text-[19px] lg:text-[20px] max-w-[20rem] sm:max-w-[24rem] md:max-w-[38rem] lg:max-w-[46rem] font-medium">
                {/* Address: */}
                {t.address1} :
                <br />
              </span>
              <span className="text-[16px] sm:text-[17px] md:text-[19px] lg:text-[20px]"
                style={{ whiteSpace: "pre-line" }}>
                {t.address2}
              </span>
            </p>

            <p>
              <span className="text-[16px] sm:text-[17px] md:text-[19px] lg:text-[20px] font-medium">
                {/* Phone:{" "} */}
                {t.phone} :
              </span>
              <span className="text-[16px] sm:text-[17px] md:text-[19px] lg:text-[20px] ml-2">
                {/* 022-22623480 / 022-22623446 */}
                {t.phone1}
              </span>
            </p>

            <p>
              <span className="text-[16px] sm:text-[17px] md:text-[19px] lg:text-[20px] font-medium">
                {/* Email:{" "} */}
                {t.email} :
              </span>
              <span className="text-[16px] sm:text-[17px] md:text-[19px] lg:text-[20px] ml-2">
                {/* mahaarchaeology@gmail.com */}
                {t.emailid}
              </span>
            </p>

            <p>
              <span className="text-[16px] sm:text-[17px] md:text-[19px] lg:text-[20px] font-medium">
                {/* Timings No.:{" "} */}
                {t.Timings} :
              </span>
              <span className="text-[16px] sm:text-[17px] md:text-[19px] lg:text-[20px] ml-2">
                {/* 10.30 am to 6.15 pm
                 (Saturday and Sunday Office will
                  be closed) */}
                {t.Timings1}
              </span>
            </p>
          </div>

          {/* Right Side Form: 6 columns */}
          <form
            onSubmit={handleSubmit}
            className="space-y-4 w-full contact-form md:col-span-7 rounded-3xl font-futura"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col space-y-1">
                <label
                  htmlFor="name"
                  className="text-base"
                  style={{ color: "#000000" }}
                >
                  {/* Name */}
                  {t.formname}
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  // placeholder="Ex. John"
                  placeholder={t.formnamePlaceholder}
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{ color: "#000000" }}
                />{" "}
                {errors.name && (
                  <p className="text-red-500 text-sm">{errors.name}</p>
                )}
              </div>
              <div className="flex flex-col space-y-1">
                <label
                  htmlFor="lastName"
                  className="text-base"
                  style={{ color: "#000000" }}
                >
                  {/* Last Name */}
                  {t.formlastname}
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  // placeholder="Ex. Doe"
                  placeholder={t.formlastnamePlaceholder}
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  style={{ color: "#000000" }}
                />{" "}
                {errors.lastName && (
                  <p className="text-red-500 text-sm">{errors.lastName}</p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col space-y-1">
                <label
                  htmlFor="phone"
                  className="text-base"
                  style={{ color: "#000000" }}
                >
                  {/* Phone No. */}
                  {t.formcontact}
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  // placeholder="+91 "
                  placeholder={t.formcontactPlaceholder}
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  pattern="\d{10}" // exactly 10 digits
                  maxLength={10}
                  style={{ color: "#000000" }}
                />{" "}
                {errors.phone && (
                  <p className="text-red-500 text-sm">{errors.phone}</p>
                )}
              </div>

              <div className="flex flex-col space-y-1">
                <label
                  htmlFor="email"
                  className="text-base"
                  style={{ color: "#000000" }}
                >
                  {/* Email */}
                  {t.formemail}
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  // placeholder="Ex. abcd123@gmail.com"
                  placeholder={t.formemailPlaceholder}
                  value={formData.email}
                  onChange={handleChange}
                  required
                  title="Enter a valid email address"
                  style={{ color: "#000000" }}
                />{" "}
                {errors.email && (
                  <p className="text-red-500 text-sm">{errors.email}</p>
                )}
              </div>
            </div>

            <div className="flex flex-col space-y-1">
              <label
                htmlFor="message"
                className="text-base"
                style={{ color: "#000000" }}
              >
                {/* Message */}
                {t.formmessage}
              </label>
              <textarea
                id="message"
                name="message"
                // placeholder="Type your message here..."
                placeholder={t.formmessagePlaceholder}
                value={formData.message}
                onChange={handleChange}
                required
                className="h-32"
                style={{ color: "#000000" }}
              />
            </div>

            <button
              type="submit"
              className="no-dark-bg allow-bg-yellow text-white px-6 py-2 rounded transition font-futura"
              style={{
                backgroundColor: "#FDAC27",
                border: "none",
              }}
            >
              {/* Send Message */}
              {t.submitButton}
            </button>
          </form>
        </div>
      </div>

      {/* Table Section */}
      <div className="mt-6 p-6" id="headoffice" >
        <h1
          style={{}}
          className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black pb-10"
        >
          {t.heading2}
        </h1>

        <div className="w-full" >
          <div className="w-full rounded-xl overflow-hidden">
            <div
              className="overflow-x-auto rounded-xl"
              style={{ border: "2px solid #F8D6BF", background: "#EFEDE0" }}
            >
              <table className="w-full min-w-[800px] text-sm sm:text-base text-black text-center">
                <thead
                  className="font-bold tracking-wide"
                  style={{
                    textShadow: "0.3px 0.3px 0 black",
                  }}
                >
                  <tr>
                    {tableHeaders1.map((header) => (
                      <th
                        key={header.key}
                        className="py-3 px-4 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {header.label[selectedLang]}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {headoffice.map((person) => (
                    <tr key={person.id}>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.name[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.post[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.division[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.address[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.email}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.contact[selectedLang]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="mt-8 p-6" id="archaeology" >
        <h1
          style={{}}
          className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black pb-10"
        >
          {t.heading}
        </h1>

        <div className="w-full" >
          <div className="w-full rounded-xl overflow-hidden">
            <div
              className="overflow-x-auto rounded-xl"
              style={{ border: "2px solid #F8D6BF", background: "#EFEDE0" }}
            >
              <table className="w-full min-w-[800px] text-sm sm:text-base text-black text-center">
                <thead
                  className="font-bold tracking-wide"
                  style={{
                    textShadow: "0.3px 0.3px 0 black",
                  }}
                >
                  <tr>
                    {tableHeaders.map((header) => (
                      <th
                        key={header.key}
                        className="py-3 px-4 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {header.label[selectedLang]}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {officials.map((person) => (
                    <tr key={person.id}>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.name[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.post[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.division[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.address[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.email}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.contact[selectedLang]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="mt-8 p-6" id="museums-contact">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] pb-10 text-black">
          {t.heading1}
        </h1>
        <div className="w-full">
          <div className="w-full overflow-hidden">
            <div
              className="overflow-x-auto rounded-xl bg-[#EFEDE0]"
              style={{ border: "2px solid #F8D6BF" }}
            >
              <table className="w-full min-w-[800px] text-sm sm:text-base text-black text-center">
                <thead
                  className="font-bold tracking-wide"
                  style={{
                    textShadow: "0.3px 0.3px 0 black",
                  }}
                >
                  <tr>
                    {museumTableHeaders.map((header) => (
                      <th
                        key={header.key}
                        className="py-3 px-4 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {header.label[selectedLang]}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {museumStaff.map((person) => (
                    <tr key={person.id}>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.name[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.post[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.division[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.address[selectedLang]}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2 border-r-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.email}
                      </td>
                      <td
                        className="py-3 px-4 border-t-2"
                        style={{ borderColor: "#F8D6BF" }}
                      >
                        {person.contact[selectedLang]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
